export default function (context, val) {
    let selections = context.state.selections;
    if(selections.indexOf(val)<0){
        selections.push(val);
    }else{
        selections.splice(selections.indexOf(val), 1);
    }
}